import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconArrowDownwardLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 16.627V5.25c0-.213.072-.391.216-.535A.725.725 0 0 1 12 4.5a.73.73 0 0 1 .535.215.726.726 0 0 1 .215.535v11.377l5.17-5.17a.706.706 0 0 1 .521-.22c.2.002.377.081.532.236a.78.78 0 0 1 .225.527.7.7 0 0 1-.225.527l-6.34 6.34a.828.828 0 0 1-.633.256.827.827 0 0 1-.633-.256l-6.34-6.34a.715.715 0 0 1-.212-.514.749.749 0 0 1 .212-.54.735.735 0 0 1 .535-.232c.2 0 .38.077.534.232l5.154 5.154Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowDownwardLine;
